const accountsLangCN = {
    accountsSecurity: "账户与安全",
    memberId: "会员id",
    phone: "手机号码",
    updatePassword: "账户与安全",
    changingPassword: "修改登录密码",
    paymentPassword: "点击设置支付密码",
    title: "当前绑定手机号",
    buttonTitle: "点击更换手机号码",
    goBack: "返回",
    title2: "当前无手机号,请点击按钮绑定",
    buttonTitle2: "点击绑定手机号码",
    titleUpdatePassword: "更改密码",
    oldPassword: "旧密码",
    newPassword: "新密码",
    repetition: "再次输入",
    submit:"提交",
}

const accountsLangEN = {
    accountsSecurity:"Account and security",
    memberId:"Member ID",
    phone:"Phone",
    updatePassword:"Accounts and Security",
    changingPassword:"Change your sign in password",
    paymentPassword:"Set your payment password here",
    title:"The current mobile phone number is bound",
    buttonTitle: "Click to change the phone number",
    goBack:"Go back",
    title2: "Currently no mobile phone number, please click the button to bind",
    buttonTitle2:"Click Bind mobile number",
    titleUpdatePassword:"Change password",
    oldPassword:"Old password",
    newPassword:"New Password",
    repetition: "Repetition",
    submit:"Submit",
}



const langPackage = {
    cn:accountsLangCN,
    en:accountsLangEN
}


export {langPackage}
